import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import ProductCard from "../components/ProductCard";
import { euro, fetchFilters, fetchProducts, specList } from "../api/shop";

export default function Home() {
  const [featured, setFeatured] = useState([]);
  const [deals, setDeals] = useState([]);
  const [brands, setBrands] = useState([]);
  const [error, setError] = useState("");

  useEffect(() => {
    let alive = true;

    Promise.all([
      fetchProducts({ limit: 8, sort: "price_desc" }),
      fetchProducts({ limit: 8, sort: "price_asc" }),
      fetchFilters(),
    ])
      .then(([top, cheap, filters]) => {
        if (!alive) return;
        setFeatured(top.items);
        setDeals(cheap.items);
        setBrands(filters.brands.slice(0, 12));
      })
      .catch((err) => alive && setError(err.message));

    return () => {
      alive = false;
    };
  }, []);

  const star = featured[0];

  useEffect(() => {
  window.scrollTo(0, 0);
}, []);

  return (
    <>
      {/* Hero: the shop's headline phone, straight from the live catalogue */}
      <section className="hero">
        <div className="wrap hero__grid">
          <div>
            <p className="eyebrow">Tienda de móviles · Canarias</p>
            <h1>
              El móvil que quieres, <mark>sin el postureo</mark> del precio.
            </h1>
            <p className="hero__lede">
             {/* Móviles libres con garantía oficial. Precio final con IGIC, envío gratis y entrega en 24–72 h. */}
             Móviles libres con garantía oficial. Precio final con IGIC, envío gratis en toda Canarias y entrega en 24–72 h.
            </p>

            <div className="hero__actions">
              <Link to="/moviles" className="btn btn--lg">
                Ver todos los móviles
              </Link>
              <Link to="/moviles?sort=price_asc" className="btn btn--ghost btn--lg">
                Empezar por los más baratos
              </Link>
            </div>
          </div>

          <div className="hero__stage">
            {star ? (
              <>
                <Link to={`/movil/${encodeURIComponent(star.sku)}`}>
                  <img src={star.image} alt={`${star.brand} ${star.title}`} />
                </Link>
                <div className="hero__stagecap">
                  <div>
                    <p className="eyebrow">{star.brand}</p>
                    <p>{star.title}</p>
                    {specList(star.specs).length > 0 && (
                      <div className="specs" style={{ marginTop: 8 }}>
                        {specList(star.specs).slice(0, 3).map((spec) => (
                          <span key={spec}>{spec}</span>
                        ))}
                      </div>
                    )}
                  </div>
                  <span className="tag tag--lg">
                    {euro(star.price)}
                    <span className="tag__cur">€</span>
                  </span>
                </div>
              </>
            ) : (
              <div className="hero__skeleton" />
            )}
          </div>
        </div>
      </section>

      {error && (
        <div className="wrap">
          <div className="alert alert--error">{error}</div>
        </div>
      )}

      {/* Brands */}
      {brands.length > 0 && (
        <section className="wrap" style={{ paddingBottom: 8 }}>
          <p className="eyebrow" style={{ marginBottom: 12 }}>
            Marcas en stock
          </p>
          <div className="brands">
            {brands.map(({ brand, count }) => (
              <Link key={brand} to={`/moviles?brand=${encodeURIComponent(brand)}`}>
                {brand}
                <b>{count}</b>
              </Link>
            ))}
          </div>
        </section>
      )}

      {/* Featured */}
      <section className="wrap section">
        <div className="section__head">
          <div>
            <p className="eyebrow">Gama alta</p>
            <h2>Los que todo el mundo mira</h2>
          </div>
          <Link to="/moviles?sort=price_desc" className="linkish">
            Ver todos
          </Link>
        </div>

        <div className="grid">
          {featured.map((product) => (
            <ProductCard key={product.sku} product={product} />
          ))}
        </div>
      </section>

      {/* Promises — plain facts, not slogans */}
      <section className="band">
        <div className="wrap band__grid">
          <div>
            <p className="eyebrow">Envío</p>
            <h3>Gratis, siempre</h3>
            <p>Sin mínimo de compra. Entrega en 24–72 h. en toda Canarias. También entregamos en Península.</p>
          </div>
          <div>
            <p className="eyebrow">Garantía</p>
            <h3>3 años oficiales</h3>
            <p>Todos los terminales son nuevos, libres y con garantía del fabricante en España.</p>
          </div>
          <div>
            <p className="eyebrow">Precio</p>
            <h3>Lo que ves es lo que pagas</h3>
            <p>IGIC y canon digital incluidos en cada precio. Sin cargos sorpresa al final.</p>
          </div>
        </div>
      </section>

      {/* Deals */}
      <section className="wrap section">
        <div className="section__head">
          <div>
            <p className="eyebrow">Menos de lo que crees</p>
            <h2>Buenos móviles, poco dinero</h2>
          </div>
          <Link to="/moviles?sort=price_asc" className="linkish">
            Ver todos
          </Link>
        </div>

        <div className="grid">
          {deals.map((product) => (
            <ProductCard key={product.sku} product={product} />
          ))}
        </div>
      </section>
    </>
  );
}
